export default "__VITE_ASSET__BCD9Ef55__"